module.exports = {"id":"192634","name":"Marc Mateu","rating":"72","photo":"./data/images/photos/3/192634.png","club":{"name":"CD Numancia","logo":"./data/images/clubs/CDNumancia.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcMateu0.json
// module id = 2697
// module chunks = 0